import TechStackScene from './TechStackScene';
import { useState, useEffect } from 'react';

const TechStack = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Set visible after a short delay for animation
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <section className="relative h-[90vh] md:min-h-screen bg-black py-0 w-full">
      <div className="absolute inset-0">
        <TechStackScene />
      </div>
      
      <div className="relative z-10 container mx-auto pt-5 px-4 flex flex-col h-full justify-between">
        <div className="text-center px-6 pt-20">
          <h2 
            className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-primary to-purple-500 
                      text-2xl md:text-4xl font-extrabold tracking-tight drop-shadow-[0_2px_5px_rgba(0,0,0,0.5)]"
            style={{
              opacity: isVisible ? 1 : 0,
              transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 1.2s ease-out, transform 1.2s ease-out',
              transitionDelay: '0.3s'
            }}
          >
            Our Tech Stack
          </h2>
          <div 
            className="h-0.5 bg-gradient-to-r from-blue-400 via-primary to-purple-500 mx-auto mt-2"
            style={{
              width: isVisible ? '120px' : '0px',
              transition: 'width 1.5s ease-out',
              transitionDelay: '0.8s'
            }}
          ></div>
        </div>
        
        <p className="text-center text-sm text-gray-400 pb-6">
           Click and drag to explore
        </p>
      </div>
    </section>
  );
};

export default TechStack;